/* eslint-disable jsx-a11y/no-autofocus */
import React, { memo } from 'react';
import styled from 'styled-components';
import { Button, Flex, Text } from 'pcln-design-system';
import { Minus, Plus } from 'pcln-icons';
const StyledFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "Counter__StyledFlex",
  componentId: "sc-14w9w2p-0"
})(["gap:12px;"]);
const PlusButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "Counter__PlusButton",
  componentId: "sc-14w9w2p-1"
})(["&&&{height:40px;padding:0;width:40px;}"]);
const MinusButton = /*#__PURE__*/styled(PlusButton).withConfig({
  displayName: "Counter__MinusButton",
  componentId: "sc-14w9w2p-2"
})(["&&&{visibility:", ";}"], props => props.disabled ? 'hidden' : 'visible');
const NoSelectText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Counter__NoSelectText",
  componentId: "sc-14w9w2p-3"
})(["width:30px;text-align:center;user-select:none;"]);
/** @public */
const Counter = ({
  autoFocus,
  className,
  count,
  label,
  min,
  max,
  onChange
}) => {
  const spacelessLabel = label && label.replace(/ /g, '-');
  const minusDisabled = count === min;
  const plusDisabled = count >= max;
  const minusLabel = `Decrease ${label}${minusDisabled ? ' - disabled' : ''}`;
  const plusLabel = `Increase ${label}${plusDisabled ? ' - disabled' : ''}`;
  const minusColor = minusDisabled ? 'background.tone' : 'error';
  const plusColor = plusDisabled ? 'background.tone' : 'primary';
  function onMinusClick() {
    return !minusDisabled && onChange(--count);
  }
  function onPlusClick() {
    return !plusDisabled && onChange(++count);
  }
  const id = `${spacelessLabel}-number`;
  const lowerCaseSpacelessLabel = id.toLowerCase();
  return React.createElement(StyledFlex, {
    alignItems: 'center',
    className: className
  }, React.createElement(MinusButton, {
    "aria-controls": id,
    "aria-label": minusLabel,
    autoFocus: !minusDisabled && autoFocus,
    "data-testid": `${lowerCaseSpacelessLabel}-radioMinus-button`,
    disabled: minusDisabled,
    id: `${lowerCaseSpacelessLabel}-radioMinus-button`,
    onClick: onMinusClick,
    type: 'button',
    variation: 'subtle'
  }, React.createElement(Minus, {
    title: minusLabel,
    color: minusColor
  })), React.createElement(NoSelectText, {
    id: id,
    "aria-live": 'polite',
    "aria-atomic": 'true',
    fontSize: 2,
    px: 2
  }, count), React.createElement(PlusButton, {
    "aria-controls": id,
    "aria-label": plusLabel,
    autoFocus: minusDisabled && autoFocus,
    "data-testid": `${lowerCaseSpacelessLabel}-radioPlus-button`,
    disabled: plusDisabled,
    id: `${lowerCaseSpacelessLabel}-radioPlus-button`,
    onClick: onPlusClick,
    type: 'button',
    variation: 'subtle'
  }, React.createElement(Plus, {
    title: plusLabel,
    color: plusColor
  })));
};
export default memo(Counter);